import { api } from '@/apis';
import { useMutation, useQueryClient } from '@tanstack/react-query';

export function useUpdateOption() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({ name, value, label, values }) => {
      return api
        .patch(`options/${name}-${value}`, {
          json: { label, values },
          headers: {
            'content-type': 'application/merge-patch+json',
          },
        })
        .json();
    },
    onSuccess: () => queryClient.invalidateQueries({ queryKey: ['options'] }),
  });
}
